import { useEffect } from 'react';
const hasBody = () => {
    return typeof document !== 'undefined' && !!document.body;
};
const useUnscrollableBody = ({ shouldAllowScroll, }) => {
    useEffect(() => {
        if (hasBody()) {
            document.body.style.overflow = shouldAllowScroll ? '' : 'hidden';
        }
        return () => {
            if (hasBody()) {
                document.body.style.overflow = '';
            }
        };
    }, [shouldAllowScroll]);
};
export default useUnscrollableBody;
//# sourceMappingURL=useUnscrollableBody.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
